<template>
    <div class="notice-list">
        <mc-operate-bar>
            <template slot="left">
                <mc-search-bar v-model="searchParmas" search-label="输入站点名称" :search-submit="$_getTableList"></mc-search-bar>
            </template>
        </mc-operate-bar>
        <mc-table ref="mc-table" :table-option="tableOption" v-loading="tableOption.loading">
            <template slot="table-components">
                <el-table-column :prop="tableOption.head[0].prop" :label="tableOption.head[0].label" :width="tableOption.head[0].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span class="deal-item" @click="dialog.siteName.methods.open(scope.row)">{{scope.row.site_name}}</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[1].prop" :label="tableOption.head[1].label" :width="tableOption.head[1].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span v-if="scope.row.alert_severity == 1">消息</span>
                        <span v-else-if="scope.row.alert_severity == 2">一般</span>
                        <span v-else-if="scope.row.alert_severity == 3">消息，一般</span>
                        <span v-else-if="scope.row.alert_severity == 4">严重</span>
                        <span v-else-if="scope.row.alert_severity == 5">消息，严重</span>
                        <span v-else-if="scope.row.alert_severity == 6">一般，严重</span>
                        <span v-else-if="scope.row.alert_severity == 7">消息，一般，严重</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[2].prop" :label="tableOption.head[2].label" :width="tableOption.head[2].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span v-if="scope.row.alert_status == 1">已消除</span>
                        <span v-else-if="scope.row.alert_status == 2">待处理</span>
                        <span v-else-if="scope.row.alert_status == 3">已消除，待处理</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[3].prop" :label="tableOption.head[3].label" :width="tableOption.head[3].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span v-if="scope.row.methods == 0"></span>
                        <span v-else-if="scope.row.methods == 1">邮件</span>
                        <span v-else-if="scope.row.methods == 2">微信</span>
                        <span v-else-if="scope.row.methods == 3">邮件，微信</span>
                        <span v-else-if="scope.row.methods == 4">APP</span>
                        <span v-else-if="scope.row.methods == 5">邮件，App</span>
                        <span v-else-if="scope.row.methods == 6">微信，App</span>
                        <span v-else-if="scope.row.methods == 7">邮件，微信，App</span>
                    </template>
                </el-table-column>
            </template>
        </mc-table>
        <mc-pager :pager-option.sync="pager" ref="notice-list-pager" @getList="$_getTableList"></mc-pager>

        <mc-dialog :dialog-option.sync="dialog.siteName">
            <template slot="content">
                <mc-layout-row label-text="站点名称" :labelWidth="120">
                    <mc-label info>{{site.site_name}}</mc-label>
                </mc-layout-row>
                <mc-layout-row label-text="省" :labelWidth="120">
                    <mc-label info>{{site.province}}</mc-label>
                </mc-layout-row>
                <mc-layout-row label-text="市" :labelWidth="120">
                    <mc-label info>{{site.city}}</mc-label>
                </mc-layout-row>
                <mc-layout-row label-text="地址" :labelWidth="120">
                    <mc-label info>{{site.address}}</mc-label>
                </mc-layout-row>
            </template>
        </mc-dialog>
    </div>
</template>

<script>
    export default {
        name: "notice-list",
        data() {
            return {
                searchParmas: '',
                site: [],
                pager: {
                    page: 1,
                    per_page: 10,
                    per_pages: [10, 20, 30, 40, 50],
                    total: 0,
                },
                tableOption: {
                    loading: false,
                    index: {
                        disable: true,
                    },
                    operations: {
                        disable: false,
                        label: "操作",
                        items: [{
                            label: "查看",
                            type: "default",
                            size: 'mini',
                            click: (index, row) => {
                                this.$_goToDetails(row);
                            },
                        }, ],
                    },
                    head: [{
                            prop: "site_name",
                            label: "站点名称",
                            width: "",
                        },
                        {
                            prop: "alert_severity",
                            label: "告警级别",
                            width: "",
                        },
                        {
                            prop: "alert_status",
                            label: "告警状态",
                            width: "",
                        },
                        {
                            prop: "methods",
                            label: "通知方式",
                            width: "",
                        },
                    ],
                    data: [],
                },
                dialog: {
                    siteName: {
                        visible: false,
                        title: "站点详情",
                        style: {
                            showConfirm: false,
                            showCancel: false,
                        },
                        methods: {
                            open: (row) => {
                                this.dialog.siteName.data.id = row.site_id;
                                this.$_getSite(row.site_id);
                                this.dialog.siteName.visible = true;
                            },
                        },
                        data: {
                            id: "",
                        },
                    }
                },
            }
        },
        mounted() {
            this.$_getTableList();
        },
        methods: {
            $_getTableList: async function () {
                this.tableOption.loading = true;
                let params = {
                    page: this.pager.page,
                    per_page: this.pager.per_page,
                    sitename: this.searchParmas
                }
                let data = await this.$api.userNoticeList.getList.getNoticeList.call(this, params);
                if (data !== false) {
                    this.pager.total = data.total;
                    this.tableOption.data = data.items;
                }
                this.tableOption.loading = false;
            },
            $_getSite: async function () {
                let params = {
                    site_id: this.dialog.siteName.data.id
                }
                let data = await this.$api.userNoticeList.getList.getSite.call(this, params);
                if (data !== false) {
                    this.site = data[0];
                }
            },
        },
        watch: {
            pager: {
                deep: true,
                handler: function () {
                    this.$_getTableList();
                },
            },
        }
    }
</script>

<style lang="less" scoped>
    .notice-list {
        .deal-item {
            cursor: pointer;
            color: #1890FF;
        }

        .content {
            min-width: 400px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .site-content {
            display: inline-flex;
            width: 100%;
            margin-bottom: 10px;

            .site-content-item {
                flex: 1
            }
        }
    }
</style>